import { POSTAG } from '@novel-segment/postag/lib/postag/ids';

export { POSTAG }

export default POSTAG
